import { baseUrl } from './api.js';

/**
 * Krok KN1 bod 2 — Nastavení -> Katastr. Stejny vzor jako
 * `assistant-settings-api.ts`: raw `fetch`, routy jsou nove a jeste nejsou
 * v generovanem `@reos/api-client` schematu.
 *
 * Klic sem chodi JEN JEDNIM SMEREM (do PUT/POST). Zpet prichazi vyhradne
 * `secretHint` - prohlizec cely klic nikdy nevidi (CLAUDE.md §6).
 */

export interface KnKeyDto {
  readonly status: 'ok' | 'invalid';
  readonly secretHint: string;
  readonly lastCheckedAt: string | null;
  readonly callsUsed: number | null;
  readonly callLimit: number | null;
  readonly keyExpiresAt: string | null;
}

export interface KnKeyStateDto {
  /** Krok KN1b — feature flag `KN_OFFICE_KEY_ENABLED` na serveru. */
  readonly enabled: boolean;
  readonly key: KnKeyDto | null;
  readonly source: 'tenant' | 'platform';
  readonly platform: {
    readonly available: boolean;
    readonly usedToday: number;
    readonly dailyLimit: number;
  };
  readonly serviceDailyLimit: number;
}

export async function getKnKeyState(): Promise<KnKeyStateDto> {
  const res = await fetch(`${baseUrl}/v1/kn/key`, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as KnKeyStateDto;
}

export async function saveKnApiKey(apiKey: string): Promise<KnKeyDto> {
  const res = await fetch(`${baseUrl}/v1/kn/key`, {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ apiKey }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return ((await res.json()) as { key: KnKeyDto }).key;
}

export interface KnVerifyDto {
  readonly ok: boolean;
  readonly state: {
    readonly callsUsed: number | null;
    readonly callLimit: number | null;
    readonly keyExpiresAt: string | null;
  } | null;
  readonly messageKey: string | null;
}

export async function verifyKnApiKey(apiKey: string): Promise<KnVerifyDto> {
  const res = await fetch(`${baseUrl}/v1/kn/key/verify`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ apiKey }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as KnVerifyDto;
}

export async function removeKnApiKey(): Promise<void> {
  const res = await fetch(`${baseUrl}/v1/kn/key`, { method: 'DELETE', credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
